// extracted by mini-css-extract-plugin
export default {"description":"style_description__9FgTR","fade-in":"style_fade-in__ZKt-r","top":"style_top__EgY2D","image":"style_image__4LjiN"};